function getDataConfigFile() {
  try {
    var request = new XMLHttpRequest();
    request.open('GET', `assets/config.json`, false);  // `false`
    request.send();

    if (request.status === 200) {
      return JSON.parse(request.response);
    } else {
      console.log("Error cargando el archivo de configuración");
      throw new Error('Error cargando el archivo de configuración');
    }
  } catch (e) {
    alert('Error cargando el archivo de configuración assets/config.json');
  }
}

let dataConfig = getDataConfigFile();

export var CONFIG = {

  //Nombre de la base de datos indexedDB
  DB_NAME: 'plexiv5',

  //Store de items en indexedDB
  ITEMS_STORE: 'schedule',

  //Store de respuestas en indexedDB
  ANSWER_STORE: 'tasks',

  //Indice para busqueda de respuestas sincronizadas
  SYNC_ANSWER_INDEX: 'sincronizado',

  //Store de Token en indexedDB
  TOKEN_STORE: 'done',

  //Store de estado en indexedDB
  STATE_STORE: 'dumped',

  //End point de los servicios plexi-rest
  // REST_END_POINT: 'https://plexiback.icfes.edu.co/plexi-rest/servicio/',
  REST_END_POINT: 'https://pruebasplexiback.icfes.gov.co/plexi-rest/servicio/',
  // REST_END_POINT: 'https://plexiback.icfes.edu.co/plexi-rest/servicio/',
  // REST_END_POINT: 'http://localhost:9090/icfes/servicio/',
  // REST_END_POINT: '/plexi-rest/servicio/',
  // URL_LAMBDA_S3: 'https://cmc3ooh56i.execute-api.us-east-1.amazonaws.com/Prod/',
  URL_LAMBDA_S3: 'https://s3.us-east-1.amazonaws.com/icf-dev-s3-plxi.icfes.gov.co/mediaContent/',

  //ruta base de imagenes/videos
  //RUTA_BASE: 'https://s3.amazonaws.com/pruelec2017/mediaContent/',
  // RUTA_BASE: 'https://axuy203vxwdp.objectstorage.us-ashburn-1.oci.customer-oci.com/n/axuy203vxwdp/b/plx.icfes.gov.co/o/mediaContent/',
  RUTA_BASE: 'https://s3.us-east-1.amazonaws.com/plxi.icfes.gov.co/mediaContent/',
  //RUTA_BASE: '/src/assets/imagesOffline/',

  //password para funcionalidad de cambio de nombre
  PASSWORD_CHANGE_NAME: dataConfig.passwordChangeName,
  //PASSWORD_CHANGE_NAME: 'pl3x1',


  //keyword para consumo de servicio de login
  // PLX_AUTH_LOGIN: dataConfig.plxAuthLogin,
  PLX_AUTH_LOGIN: 's3rv1c3fr0mpl3x1',

  //constante que establece el lenguaje por defecto
  LANGUAGE: 'es',

  //constante para establecer la cantidad máxima de caracteres en pregunta abierta
  MAXLENGTH: 100,

  //separador parametros de encripción archivo
  SEPARATOR_ENCRIP: '_VVVVV_',

  /** Site Key utilizado para ejecutar reCAPTCHA V3 */
  //SITE_KEY: '6Ldqe9EZAAAAAPrMeu_qS1ZhNslHlag2RN4qC9Pc',
  SITE_KEY: '6LfyWrEZAAAAAFKvy6RXjvKye7RcT_adxSyAHG_I',

  /** Url utilizada para verificar el sitio; utilizando el secret_key y el token como parametros
   *  retorna un JSON con la siguiente información:
   *  - success
  */
  SITE_VERIFY: 'https://tj23xmpmqa.execute-api.us-east-1.amazonaws.com/v1/verify/',


  /**URL servicio de Proctoring de Territorium */
  URL_CHAT: 'https://icfes.edtest.ai/tests/chatexterno.php',

  /**URL servicio de Proctoring de Territorium */
  URL_PROCTORING: 'https://icfes.edtest.ai/tests/proctoringexterno.php',

  /**appKey que se usa para invocar el servicio de Proctoring de Territorium */
  APP_KEY: '34c0-11ed-8b82-00224823d21d',

  /** Codigo del comb para simulacion en preIcfes comunicacion Escrita */ //FIXME
  TEST_CODE_PA_PRO: 876,

  /** Codigo del comb para simulacion en preIcfes comunicacion Escrita */ //FIXME
  TEST_CODE_PA_TYT: 875,

  TEST_CODE_PI: "0002",

  CACHE_NAME: "precache-v4",

  VERSIONAPP: "1.11.8",

  TIME_OUT_CACHE: 150000,

  KEY_KIOSKO: "key_kiosko",

  ONLINE: true,

  URL_AUTENTICACION_PRISMA: 'https://resultadosbackendoci.icfes.edu.co/api/',
  URL_HABILITAR_CERTIFICADO: 'https://resultadosbackendoci.icfes.edu.co/api/',
  URL_CERTIFICADO_ASISTENCIA: 'https://resultadosbackendoci.icfes.edu.co/api/',
  TOKEN_CERTIFICADO_ASISTENCIA: 'ZmKzA4k*4nATTkYr8EuPgxntWC%7S**u%d7^g!C#6d7c3dFLHv9cuqPX5oTi#*e$#Ent9!fb6znz%wdRHH8$&i&5FV6nhUx*H5SsVQ9YKE&Gzo#DW8Yh@o@9P6VKh*PU',
  APPLICATION_CERTIFICADO_ASSISTENCIA: 'resultadosUnificadosHistoricos'

}

export var CONFIGSUMADI = {

  //Nombre de la base de datos indexedDB
  NAME: 'Sumadi',
  URL: 'https://icfes.sumadi.net/lti/v1',
  KEY: 'ICFESLT-YwZGqwKJxtQnyKxy',
  SECRET: 'zssv9dkPXNYV6CBz',
  ACCOUNT_ID: '65246b5c52000cd83c576aa4',
  REDIRECT_URL: 'https://mejorsaberpx.icfes.gov.co/'

}
